import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import igLogo from '../assets/ig-logo.png';
import { EVENTO_ROUTE } from '../routes';

const TOKEN_STORAGE_KEY = 'evento_token_v1';
const USER_STORAGE_KEY = 'evento_user_v1';
const USERNAME_STORAGE_KEY = 'evento_username_v1';
const SESSION_CHANGE_EVENT = 'evento:session-change';

const Footer: React.FC = () => {
  const location = useLocation();
  const [hasSession, setHasSession] = useState<boolean>(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    return Boolean(window.localStorage.getItem(TOKEN_STORAGE_KEY));
  });
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  useEffect(() => {
    const syncSession = () => {
      if (typeof window === 'undefined') {
        setHasSession(false);
        return;
      }
      setHasSession(Boolean(window.localStorage.getItem(TOKEN_STORAGE_KEY)));
    };

    syncSession();
    window.addEventListener(SESSION_CHANGE_EVENT, syncSession);
    return () => {
      window.removeEventListener(SESSION_CHANGE_EVENT, syncSession);
    };
  }, []);

  useEffect(() => {
    if (!hasSession) {
      setShowLogoutModal(false);
    }
  }, [hasSession]);

  const isEventoRoute = location.pathname === EVENTO_ROUTE;
  const showLogoutButton = isEventoRoute && hasSession;

  const handleConfirmLogout = () => {
    if (typeof window === 'undefined') {
      return;
    }

    window.localStorage.removeItem(TOKEN_STORAGE_KEY);
    window.localStorage.removeItem(USER_STORAGE_KEY);
    window.localStorage.removeItem(USERNAME_STORAGE_KEY);
    window.dispatchEvent(new CustomEvent(SESSION_CHANGE_EVENT, { detail: { token: null } }));
    setShowLogoutModal(false);
    window.location.reload();
  };

  return (
    <footer className="footer py-4">
      <Container>
        <div className="footer-divider mb-4"></div>
        <Row className="align-items-center">
          <Col xs={6} className="text-start">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="d-flex align-items-center"
            >
              <a
                href="https://www.instagram.com/jgwineclub/"
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex align-items-center text-decoration-none"
              >
                <img
                  src={igLogo}
                  alt="Instagram"
                  className="ig-logo me-2"
                />
                <span className="text-white">jgwineclub</span>
              </a>
            </motion.div>
          </Col>
          <Col xs={6} className="text-end">
            <div className="footer-right">
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="mb-0 text-white footer-right-text"
              >
                Somos tu club de vinos
              </motion.p>
              {showLogoutButton && (
                <button
                  type="button"
                  className="footer-logout-button"
                  aria-label="Cerrar sesión"
                  onClick={() => setShowLogoutModal(true)}
                >
                  <i className="fas fa-sign-out-alt" aria-hidden="true" />
                </button>
              )}
            </div>
          </Col>
        </Row>
      </Container>

      {showLogoutButton && showLogoutModal && (
        <div className="logout-modal-backdrop" role="dialog" aria-modal="true">
          <div className="logout-modal">
            <h3>¿Cerrar sesión?</h3>
            <p>¿Estás seguro que deseas cerrar sesión?</p>
            <div className="logout-modal-actions">
              <button type="button" className="logout-modal-button primary" onClick={handleConfirmLogout}>
                Cerrar sesión
              </button>
              <button type="button" className="logout-modal-button" onClick={() => setShowLogoutModal(false)}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
